function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { chunk } from 'lodash';

// @ts-ignore
import { DollarRecognizer, Point } from './UnistrokeRecognizer';
export class Recognizer {
  constructor() {
    _defineProperty(this, "dollar", new DollarRecognizer());
  }
  recognize(points) {
    let minX = Number.MAX_VALUE;
    let maxX = -Number.MAX_VALUE;
    let minY = Number.MAX_VALUE;
    let maxY = -Number.MAX_VALUE;
    const result = this.dollar.Recognize(chunk(points, 2).map(v => {
      minX = Math.min(minX, v[0]);
      maxX = Math.max(maxX, v[0]);
      minY = Math.min(minY, v[1]);
      maxY = Math.max(maxY, v[1]);
      return new Point(v[0], v[1]);
    }), true);
    if (result.Score > 0.7) {
      return {
        shape: result.Name,
        minX,
        minY,
        maxX,
        maxY
      };
    }
    return null;
  }
}